import type { ReactNode } from "react";
import { Link } from "react-router-dom";

type Props = {
  title: string;
  subtitle?: string;
  children: ReactNode;
};

export function AuthLayout({ title, subtitle, children }: Props) {
  return (
    <div className="auth">
      <nav className="auth__navbar">
        <Link to="/welcome" className="auth__navbar-brand" aria-label="AgroHodowca — strona główna">
          <img
            src="/static/img/logo.png"
            width={40}
            height={40}
            alt=""
            className="auth__navbar-logo"
          />
          <span className="auth__navbar-name">
            Agro<span className="auth__navbar-hodowca">Hodowca</span>
          </span>
        </Link>
        <Link to="/welcome" className="auth__navbar-link">
          O aplikacji
        </Link>
      </nav>
      <div className="auth__body">
        <div className="auth__card">
          <div className="auth__header">
            <h1 className="auth__title">{title}</h1>
            {subtitle ? <p className="auth__subtitle">{subtitle}</p> : null}
          </div>
          {children}
        </div>
      </div>
      <footer className="auth__legal">
        <Link to="/privacy" target="_blank" rel="noopener noreferrer">
          Polityka prywatności
        </Link>
      </footer>
    </div>
  );
}
